import { render, staticRenderFns } from "./purchaseOrderNew.vue?vue&type=template&id=367bd824&"
import script from "./purchaseOrderNew.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports